// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiBaseUrl: 'https://tst.virtualservices.mohawkind.com/SOAT302/vPUB.MHK.COMMCLOUD.OCC.Custom.svc/',
  hostURL: "https://dev.mohawkbuilder.com",
  // addressValidationClientId: "eMpower_hybris",
  virtualServicesAddressValidate:
    "https://pubqas.virtualservices.mohawkind.com/SOAQ405/vPUB.MHK.CREST.xchange.ABAP.svc/Z_XPS_ADDRVAL_SRV/ADDR_VALIDATESet",
  // addressValidationSecret: "Gr3@tJo8!",
  onDemand: {
    baseUrl:
      "https://tst.virtualservices.mohawkind.com/SOAT302/vPUB.MHK.COMMCLOUD.OCC.Custom.svc/",
    // apiUser: '/services/v2/pergo/users/',
  apiAuth:
      "/token?grant_type=ping-sso",
    // clientId: "occ_testUser",
    // secret: "Mohawk@123",
  },
  aptCheckBaseUrl:
    "https://tst.virtualservices.mohawkind.com/SOAT302/vPUB.MHK.COMMCLOUD.OCC.Custom.svc/",
  // sentinentUser: "eMpower_hybris",
  // sentinentPwd: "Gr3@tJo8!",
  // baseASMAPIURl:
  //   "https://api.cjjsup9vs1-mohawkcar2-d1-public.model-t.cc.commerce.ondemand.com/",
  mohawkXchangeAppUrl: "https://dev-alpha.mohawkxchange.com",
  openAMUrl:"https://ssoproxytst.mohawkind.com/proxy/OIDCintermediate.jsp?RelayState=",
  // pingRedirect: "https://auth-sbx.mohawkind.com/am/XUI/?realm=/alpha&ForceAuth=true&authIndexType=service&authIndexValue=Azure_OIDC-dynTheme&forceAuth=true",
  pingRedirect: "https://openam-mhkping-usaeast1-sandbox.rapid.id.forgerock.io/am/XUI/?realm=/alpha&authIndexType=service&authIndexValue=Azure_OIDC",
  // openAMRedirect:"https://ssoproxytst.mohawkind.com/proxy/XUI/?realm=connector&ForceAuth=true&service=Azure_oidc&goto=",
  openAMLogIn:"https://ssoproxytst.mohawkind.com/proxy/XUI/?realm=connector&ForceAuth=true&service=Azure_oidc&goto=",
  virtualServicesOrderDetail: "https://pubqas.virtualservices.mohawkind.com/SOAQ405/vMHK.CREST.Ecommerce.CAMSCGI2.REST.svc",
  addressReqHistoryPS:"https://ps-tools-dev.azurewebsites.net/api/xchgAddressReqHistory"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
